export default [
    {
        path: '/workshop/order/list/:filter?',
        name: 'workshop_order_list',
        component: () => import('@src/workshop/workshop-order-list'),
        meta: {
            title: 'Werkstattaufträge',
            role: 'ROLE_LIST_WORKSHOP_ORDER',
        },
    },
    {
        path: '/workshop/order/create/:tab?',
        name: 'workshop_order_create',
        component: () => import('@src/workshop/workshop-order-create'),
        meta: {
            title: 'Neuen Werkstattauftrag anlegen',
            role: 'ROLE_EDIT_WORKSHOP_ORDER',
        },
    },
    {
        path: '/workshop/order/edit/:id',
        name: 'workshop_order_edit',
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        component: () => import('@src/workshop/workshop-order-edit'),
        meta: {
            title: 'Werkstattauftrag bearbeiten',
            role: 'ROLE_EDIT_WORKSHOP_ORDER',
        },
    },
    {
        path: '/workshop/current-orders/:tab?',
        name: 'workshop_current_orders',
        component: () => import('@src/workshop/current-orders'),
        meta: {
            title: 'Aktuelle Aufträge',
            role: 'ROLE_LIST_WORKSHOP_ORDER',
        },
    },
    {
        path: '/workshop/work-unit/list/:filter?',
        name: 'workshop_work_unit_list',
        component: () => import('@src/workshop/work-unit/work-unit-list'),
        meta: {
            title: 'Arbeitswerte',
            role: 'ROLE_LIST_WORK_UNIT',
        },
    },
    {
        path: '/workshop/work-unit/edit/:id?',
        name: 'workshop_work_unit_edit',
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/workshop/work-unit/work-unit.vue'),
        meta: {
            title: 'Arbeitswert bearbeiten',
            role: 'ROLE_EDIT_WORK_UNIT',
        },
    },
    {
        path: '/workshop/date-config',
        name: 'workshop_date_config',
        component: () => import('@src/workshop/date-config/workshop-date-config'),
        meta: {
            title: 'Annahmekapazität',
            role: 'ROLE_EDIT_WORKSHOP_WEEKDAY_CONFIG',
        },
    },
    {
        path: '/workshop/work-unit-customer',
        name: 'workshop_work_unit_customer',
        component: () => import('@src/workshop/work-unit-customer/work-unit-customer'),
        meta: {
            title: 'Arbeitsleistungen Terminvereinbarung',
            role: 'ROLE_EDIT_WORK_UNIT',
        },
    },
    {
        path: '/workshop/week-day-config',
        name: 'workshop_week_day_config',
        component: () => import('@src/workshop/weekday-config/weekday-config-edit'),
        meta: {
            title: 'Kapazität pro Wochentag',
            role: 'ROLE_EDIT_WORKSHOP_WEEKDAY_CONFIG',
        },
    },
    {
        path: '/workshop/work-unit-price-group/list',
        name: 'workshop_work_unit_price_group_list',
        component: () => import('@src/workshop/work-unit-price-group/work-unit-price-group-list.vue'),
        meta: {
            title: 'Arbeitswertgruppen',
            role: 'ROLE_LIST_WORK_UNIT_PRICE_GROUP',
        },
    },
    {
        path: '/workshop/work-unit-price-group/:id?',
        name: 'workshop_work_unit_price_group',
        component: () => import('@src/workshop/work-unit-price-group/work-unit-price-group.vue'),
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        meta: {
            title: 'Arbeitswertgruppe',
            role: 'ROLE_EDIT_WORK_UNIT_PRICE_GROUP',
        },
    },
];
